import { render, staticRenderFns } from "./InfoWithHighlightsBlock.vue?vue&type=template&id=41e415b9"
import script from "./InfoWithHighlightsBlock.vue?vue&type=script&lang=js"
export * from "./InfoWithHighlightsBlock.vue?vue&type=script&lang=js"
import style0 from "./InfoWithHighlightsBlock.vue?vue&type=style&index=0&id=41e415b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports